<app-backgrop [noColor]="true" class="relative z-100" (pointerup)="closeModal($event)">
  <div class="w-full max-w-[1200px] flex flex-col items-center justify-center relative min-h-full">
    <div class="flex flex-col items-center w-full max-w-3xl px-6 sm:px-unset pb-[100px]">
      <div
        class="uppercase bg-black/50 px-4 py-2 md:px-8 md:py-4 font-medium text-white text-[22px]/[110%] md:text-4xl/[110%] rounded-lg mb-6 sm:mb-8 md:mb-10 shrink-0"
      >
        {{ currentModalData.title }}
      </div>

      <div
        class="w-full bg-black/50 p-2 sm:p-4 md:px-8 md:py-4  text-white text-base/[130%] md:text-[22px]/[130%] rounded-lg mb-6 shrink-0 text-center"
        [innerHTML]="currentModalData.desc"
      >
      </div>
    </div>

    <app-comment class="absolute left-1/2 transform -translate-x-1/2 bottom-8 md:bottom-16" ><span [innerHTML]="currentModalData.action"></span></app-comment>
  </div>
</app-backgrop>
